if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      /* Strip /fr or /ar prefix → primary-root path */
      stripLocalePrefix(path) {
        var cleaned = String(path || '/').replace(/^\/(fr|ar)(?=\/|$)/i, '');
        return cleaned || '/';
      }

      /* Map size filter values between FR (ans) and AR (سنوات) */
      mapSizeFilterQuery(qs, targetCode) {
        if (!qs) return qs;
        try {
          var params = new URLSearchParams(qs.charAt(0) === '?' ? qs.slice(1) : qs);
          var toFr = String(targetCode || '').toLowerCase() === 'fr';
          var changed = false;
          Array.from(params.keys()).forEach(function (key) {
            if (key.indexOf('filter.v.option.') !== 0) return;
            var raw = params.get(key) || '';
            var next = toFr ? raw.replace(/سنوات/g, 'ans') : raw.replace(/\bans\b/gi, 'سنوات');
            if (next !== raw) {
              params.set(key, next);
              changed = true;
            }
          });
          if (!changed) return qs;
          var out = params.toString().replace(/%20/g, '+');
          return out ? '?' + out : '';
        } catch (e) {
          return qs;
        }
      }

      /* Build return_to for target locale (Arabic = /, French = /fr/...) */
      buildReturnTo(localeCode) {
        var path = this.stripLocalePrefix(window.location.pathname);
        var qs = window.location.search || '';
        var hash = window.location.hash || '';
        var code = String(localeCode || '').toLowerCase();

        if (code === 'ar') {
          code = 'en';
        }

        qs = this.mapSizeFilterQuery(qs, code);

        if (code === 'fr') {
          if (path === '/') return '/fr' + qs + hash;
          return '/fr' + path + qs + hash;
        }

        return path + qs + hash;
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        if (!this.elements.input || !form) return;

        let value = event.currentTarget.dataset.value;

        /* Bambé: never switch to Markets /ar — use primary root (en) */
        if (String(value).toLowerCase() === 'ar' || event.currentTarget.getAttribute('data-bambe-ar-root') === '1') {
          if (String(value).toLowerCase() === 'ar') value = 'en';
        }

        this.elements.input.value = value;

        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.appendChild(returnTo);
        }
        returnTo.value = this.buildReturnTo(value);

        form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
